export default "__VITE_ASSET__CdrBesrX__"